<template>
  <div>
    <div class="container">
      <div class="row justify-content-md-center">
        <div class="col-md-12">
          <div class="page-header bordered mb0" style="padding-bottom: 0px;">
            <h3> {{ event.title }} </h3>
          </div>
        </div>
      </div>
    </div>

    <div id="content" class="item-single">
      <div class="container">
        <div class="row justify-content-md-center">
          <div class="col-md-12">
            <div class="card">
              <div class="card-header" role="tab" id="headingOne">
                <h5 class="panel-title" style="margin: 0px;">
                  Event Information
                </h5>
              </div>
              <div class="card-body" style="padding-bottom: 0px;">
                <p>
                  <i class="fa fa-map-marker" aria-hidden="true"></i>
                  {{ event.venue_name}}: {{ eventAddress() }}
                </p>
                <p>
                  <i class="fa fa-calendar" aria-hidden="true"></i>
                  Event: {{ dateRange() }}
                </p>
                <p>
                  <i class="fa fa-calendar" aria-hidden="true"></i>
                  Sales: {{ salesDateRange() }}
                </p>
              </div>
            </div>
          </div>

          <div class="col-md-12">
            <div class="card">
              <div class="card-header" role="tab" id="headingOne">
                <h5 class="panel-title" style="margin: 0px;">
                  Sales information
                </h5>
              </div>
              <div class="card-body" style="padding-bottom: 0px;">
                <div v-for="(ticket, index) in event.tickets_attributes"
                  :key="index">
                  <h5>
                    <i class="fa fa-ticket"></i>
                    {{ ticket.description || 'N/A' }}
                  </h5>
                  <hr/>

                  <b-card>
                    <b-card-sub-title class="mb-2">
                      <b>{{ ticketsSold(ticket) }} Tickets Sold / {{ ticket.quantity }}</b>
                    </b-card-sub-title>
                    <b-card-text>
                      <div class="row justify-content-md-center">
                        <div class="col-md-10">
                          <b-progress :max="ticket.quantity" height="2rem">
                            <b-progress-bar :value="ticketsSold(ticket)" variant="success" />
                          </b-progress>
                        </div>
                        <div class="col-md-2">
                          <strong>
                            {{ ((ticketsSold(ticket) / ticket.quantity) * 100).toFixed(0) }}%
                          </strong>
                        </div>
                      </div>
                    </b-card-text>
                  </b-card>

                  <div class="row justify-content-md-center">
                    <div class="col-md-6">
                      <b-card class="text-primary pb-1">
                        <b-card-sub-title class="mb-1" sub-title-text-variant="primary">
                          Net sales
                        </b-card-sub-title>
                        <b-card-text>
                          <h3 class="text-primary m-0">
                            {{ (ticketsSold(ticket) * ticket.price) / 100 | currency }}
                          </h3>
                        </b-card-text>
                      </b-card>
                    </div>

                    <div class="col-md-6">
                      <b-card class="text-dark pb-1">
                        <b-card-sub-title class="mb-1" sub-title-text-variant="dark">
                          Tickets sold
                        </b-card-sub-title>
                        <b-card-text>
                          <h3 class="text-dark m-0">
                            {{ ticketsSold(ticket) }}
                          </h3>
                        </b-card-text>
                      </b-card>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-12">
            <div class="card">
              <div class="card-header" role="tab" id="headingOne">
                <h5 class="panel-title" style="margin: 0px;">
                  Purchasers
                  <small class="float-right">
                    <b-button class="btn btn-sm btn-primary" @click="exportPurchasesToCSVFile()">
                      Export to CSV
                    </b-button>
                  </small>
                </h5>
              </div>

              <div class="card-body" style="padding-bottom: 0px;">
                <div v-if="eventPurchases.length === 0">
                  <div class="alert alert-info" align="center">
                    <strong>No purchases available...</strong>
                  </div>
                </div>

                <div v-else>
                  <div class="form-group">
                    <input type="text" class="form-control" v-model="filterPurchase"
                      placeholder="Filter by Name or Email">
                  </div>

                  <table class="table">
                    <thead>
                      <tr>
                        <th scope="col" class="text-center">
                          <i class="fa fa-calendar" aria-hidden="true"></i>
                        </th>
                        <th scope="col">Name</th>
                        <th scope="col">Email</th>
                        <th scope="col">Ticket Qty</th>
                        <th scope="col" class="text-center">
                          <i class="fa fa-usd" aria-hidden="true"></i>
                        </th>
                        <th scope="col">Payment Type</th>
                        <th scope="col">Status</th>
                        <th scope="col" v-show="$localStorage.get('user_type').match(/admin|client_admin/)">
                          Actions
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(purchase, index) in this.filteredPurchases" :key="index">
                        <td>
                          {{ moment(purchase.purchased_at).format("MM/DD/YY HH:mm") }}
                        </td>
                        <td> {{ purchase.user.first_name + ' ' +  purchase.user.last_name }} </td>
                        <td> {{ purchase.user.email }} </td>
                        <td :id="'ticket-details-' + index">
                          {{ purchase.tickets_quantity }}
                          <b-popover :target="'ticket-details-' + index" triggers="hover"
                            placement="top">
                            <table>
                              <thead>
                                <tr>
                                  <th> Ticket </th>
                                  <th> Qty </th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr v-for="(purchaseTicket, index) in purchase.purchase_tickets" :key="index">
                                  <td> {{ purchaseTicket.ticket.description }} </td>
                                  <td class="text-center"> {{ purchaseTicket.ticket_quantity}} </td>
                                </tr>
                              </tbody>
                            </table>
                          </b-popover>
                        </td>
                        <td> {{ purchase.formatted_amount }} </td>
                        <td class="text-center">
                          <i v-if="purchase.gift_card_code_redeem" title="cash"
                            class="fa fa-gift fa-lg" aria-hidden="true"></i>
                          <i v-else class="fa fa-credit-card fa-lg" title="credit card"
                          aria-hidden="true"></i>
                        </td>
                        <td class="text-center">
                          <PurchaseStatus
                            :status="purchase.status"
                          />
                        </td>
                        <td  class="text-center">
                          <button v-show="$localStorage.get('user_type').match(/admin|client_admin/) && canBeRefunded(purchase)"
                            type="button" class="btn btn-sm btn-light"
                            title="make refund" v-on:click="startRefund(purchase)">
                            <i class="fa fa-undo"></i>
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EventService from '../../../services/EventService'
import EventPurchaseService from '../../../services/EventPurchaseService'
import PurchaseStatus from '../../common/PurchaseStatus'
import axios from 'axios'

export default {
  name: 'UserEventShow',
  components: {
    PurchaseStatus
  },
  data: function () {
    return {
      eventId: this.$route.params.id,
      event: {
        event_type: '',
        topic: '',
        event_dates_attributes: [{}]
      },
      eventPurchases: [],
      filterPurchase: '',
      currencyFormat: new Intl.NumberFormat(
        'en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 2 }
      )
    }
  },
  computed: {
    filteredPurchases () {
      var self = this

      if (this.filterPurchase) {
        return this.eventPurchases.filter((purchase) => {
          return purchase.user.email.match(self.filterPurchase) ||
            purchase.user.first_name.match(self.filterPurchase) ||
            purchase.user.last_name.match(self.filterPurchase) ||
            purchase.order_number.match(self.filterPurchase)
        })
      } else {
        return this.eventPurchases
      }
    }
  },
  created () {
    this.getEvent()
  },
  methods: {
    getEvent () {
      let self = this
      let loader = this.$loading.show()

      const eventRequest = EventService.getEvent(this.eventId)
      const eventPurchasesRequest = EventPurchaseService.getEventPurchases(this.eventId)

      axios.all([eventRequest, eventPurchasesRequest])
        .then(axios.spread((eventResponse, eventPurchasesResponse) => {
          self.event = eventResponse.data
          self.eventPurchases = eventPurchasesResponse.data
        })).finally(() => {
          loader.hide()
        })
    },
    eventAddress () {
      return this.event.address_1 + ', ' + this.event.city + ', ' + this.event.state
    },
    dateRange () {
      return this.event.event_dates_attributes[0].formatted_starts_at +
        ' - ' + this.event.event_dates_attributes[0].formatted_ends_at
    },
    salesDateRange () {
      return this.event.event_dates_attributes[0].formatted_sales_starts_at +
        ' - ' + this.event.event_dates_attributes[0].formatted_sales_ends_at
    },
    canBeRefunded (purchase) {
      return purchase.status.match(/processed|failed_refund|request_refund/)
    },
    ticketsSold (ticket) {
      return ticket.quantity - ticket.on_sale
    },
    startRefund (purchase) {
      if (!this.$localStorage.get('user_type').match(/admin|client_admin/)) {
        this.$swal({
          title: 'You are not authorized to make a refund',
          type: 'warning'
        })

        return false
      }
      const self = this

      this.$swal({
        title: 'Confirm purchase refund?',
        text: "You won't be able to revert this!",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Refund!'
      }).then((result) => {
        if (result.value) {
          let loader = this.$loading.show()

          self.$http.post('/purchase_refunds', { purchase: { id: purchase.id } }).then(function (response) {
            purchase['status'] = 'refunded'

            self.$swal({
              title: 'Purchase refunded!',
              type: 'success'
            })
          }).catch(function (error) {
            if (error) {
              self.$swal({
                title: 'Error refunding Purchase!',
                type: 'error'
              })
            }
          }).finally(function () {
            loader.hide()
          })
        }
      })
    },
    exportPurchasesToCSVFile () {
      var self = this
      var headersCSV = {
        'order_number': 'Order Number',
        'user_name': 'Name',
        'user_email': 'Email',
        'tickets_quantity': 'Tickets Qty.',
        'formatted_amount': 'Price',
        'payment_type': 'Payment Type',
        'status': 'Status',
        'purchased_at': 'Purchased At'
      }

      // Convert Object to JSON
      var headers = JSON.stringify([headersCSV])
      var purchasesList = this.eventPurchases.map((purchase) => {
        return {
          'order_number': purchase.order_number,
          'user_name': `${purchase.user.first_name} ${purchase.user.last_name}`,
          'user_email': purchase.user.email,
          'tickets_quantity': purchase.tickets_quantity,
          'formatted_amount': purchase.formatted_amount,
          'payment_type': purchase.payment_type,
          'status': purchase.status,
          'purchased_at': self.moment(purchase.purchased_at).format('MM/DD/YY HH:mm')
        }
      })

      this.exportPurchasesLink(purchasesList, headers, this.event.title + '-purchases.csv')
    }
  }
}
</script>
